import moment from "moment";

export function isInvalidPeriod(periodo: any) {
  // Obtenemos la fecha actual para validar que no se solicita un periodo superior a un año
  let currentDate = moment().startOf('month');
  return currentDate.diff(moment(`01/${periodo.mes}/${periodo.anio}`, 'DD/MM/YYYY'), 'days') > 366
}
